module.exports = __webpack_public_path__ + "static/247customer-support-2757bb077c128c1bd4900eb4631fd032.png";